<app-dashboard-container
	class="dashboard-beoogd-irt-behaald"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),permanentFilterExpressions,$event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-weergave-optie label="Weergave" param="verschilbeoogd" [value]="verschilbeoogd()" [enum]="VerschilBeoogd">
			</app-weergave-optie>
			<app-legenda class="cl-header-utility" [attribute]="waardePath()" [keyIsClassName]="true"></app-legenda>
		</app-dashboard-header>
			@switch (variant()) {
				@case (DashboardVariant.ACTUEEL) {
					<app-barchart-table
						[filters]="filterExpressions()"
						[permanentFilters]="permanentFilterExpressions"
						[groups]="groeperingService.huidigeGroeperingen()"
						[subgroups]="subgroups()"
						[config]="this"
					></app-barchart-table>
				}
				@case (DashboardVariant.HISTORIE) {
					<app-vbarchart-table
						[filters]="filterExpressions()"
						[permanentFilters]="permanentFilterExpressions"
						[groups]="historieGroups()"
						[subgroups]="historieSubgroups()"
						[batchLevels]="isHistorieBatchVariant() ? 1 : 0"
						[config]="this"
						[partitionMeasure]="partitionMeasure"
						[schooljaarPath]="['ds_nm_schooljaar_van']"
					></app-vbarchart-table>
				}
		}
	</section>
</app-dashboard-container>
